import { Navigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { ME } from '../graphql/auth';
import Loading from './shared/Loading';

const PrivateRoute = ({ children, allowedRoles, modulo }) => {
  const token = localStorage.getItem('token');
  const { data, loading, error } = useQuery(ME, {
    skip: !token,
  });

  // Si no hay token, redirigir al login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Mientras carga, mostrar loading
  if (loading) {
    return <Loading fullScreen />;
  }

  // Si hay error o no hay usuario, redirigir al login
  if (error || !data?.me) {
    localStorage.removeItem('token');
    return <Navigate to="/login" replace />;
  }

  const userRole = data.me.rol;

  // superadmin y admin siempre tienen acceso
  if (userRole === 'superadmin' || userRole === 'admin') {
    return children;
  }

  // Verificar roles si se especificaron
  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Verificar permiso por módulo (ej: "configuracion" → busca configuracion.*)
  if (modulo) {
    const permisos = data.me.permisos_efectivos || [];
    const tieneAcceso = permisos.some(p => p.startsWith(`${modulo}.`));
    if (!tieneAcceso) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Usuario autenticado y autorizado
  return children;
};

export default PrivateRoute;
